import React, {FC} from "react"
import {TableHeader, TableHeaderCell, TableRow} from "semantic-ui-react"
import { FormattedMessage, useIntl } from "react-intl"
import {Locale} from "../../locale"
import {DatepickerHint} from "../../datepicker/datepicker-hint"


export const CreatorIndiHeader: FC = () => {
    const intl = useIntl()

    return (
        <TableHeader>
            <TableRow>
                <TableHeaderCell className="sticky-header enabled-column">&nbsp;</TableHeaderCell>
                <TableHeaderCell className="sticky-header" textAlign="center"><FormattedMessage id="creator.column.individual.id"/>&nbsp;<span style={{color: "red"}}>*</span></TableHeaderCell>
                <TableHeaderCell className="sticky-header" textAlign="center" collapsing><FormattedMessage id="creator.column.individual.sex"/>&nbsp;<span style={{color: "red"}}>*</span></TableHeaderCell>
                <TableHeaderCell className="sticky-header" width={1}><FormattedMessage id="creator.column.individual.name"/></TableHeaderCell>
                {(() => {
                    switch (intl.locale) {
                        case Locale.ES:
                            return (
                                <>
                                    <TableHeaderCell className="sticky-header" width={1}><FormattedMessage id="creator.column.individual.surname1"/></TableHeaderCell>
                                    <TableHeaderCell className="sticky-header" width={1}><FormattedMessage id="creator.column.individual.surname2"/></TableHeaderCell>
                                </>
                            )
                        case Locale.EN:
                        case Locale.PL:
                        default:
                            return (
                                <>
                                    <TableHeaderCell className="sticky-header" width={1}><FormattedMessage id="creator.column.individual.middlename"/></TableHeaderCell>
                                    <TableHeaderCell className="sticky-header" width={1}><FormattedMessage id="creator.column.individual.surname1"/></TableHeaderCell>
                                </>
                            )
                    }
                })()}
                <TableHeaderCell className="sticky-header"><FormattedMessage id="creator.column.individual.birthDate"/><DatepickerHint position="top right"/></TableHeaderCell>
                <TableHeaderCell className="sticky-header"><FormattedMessage id="creator.column.individual.birthPlace"/></TableHeaderCell>
                <TableHeaderCell className="sticky-header" collapsing><FormattedMessage id="creator.column.individual.deceaseDate"/><DatepickerHint position="top left"/></TableHeaderCell>
                <TableHeaderCell className="sticky-header"><FormattedMessage id="creator.column.individual.deceasePlace"/></TableHeaderCell>
                <TableHeaderCell className="sticky-header parents-dropdown id" textAlign="center" collapsing><FormattedMessage id="creator.column.individual.fatherId"/></TableHeaderCell>
                <TableHeaderCell className="sticky-header parents-dropdown id" textAlign="center" collapsing><FormattedMessage id="creator.column.individual.motherId"/></TableHeaderCell>
                <TableHeaderCell className="sticky-header" textAlign="center">&nbsp;</TableHeaderCell>
                <TableHeaderCell className="sticky-header"><FormattedMessage id="creator.column.individual.notes"/></TableHeaderCell>
                <TableHeaderCell className="sticky-header remove-column" collapsing>&nbsp;</TableHeaderCell>
            </TableRow>
        </TableHeader>
    )
}